import type * as React from 'react'
import { PlateLeaf } from 'platejs/react'
import type { PlateLeafProps } from 'platejs/react'

type MarkLeafElement = 'em' | 's' | 'strong' | 'u'
type MarkLeafProps = PlateLeafProps & { as: MarkLeafElement }

const MarkLeaf = ({ as, ...props }: MarkLeafProps): React.ReactElement => (
  <PlateLeaf {...props} as={as} />
)

const BoldLeaf = (props: PlateLeafProps): React.ReactElement => (
  <MarkLeaf {...props} as="strong" />
)

const ItalicLeaf = (props: PlateLeafProps): React.ReactElement => (
  <MarkLeaf {...props} as="em" />
)

const UnderlineLeaf = (props: PlateLeafProps): React.ReactElement => (
  <MarkLeaf {...props} as="u" />
)

const StrikethroughLeaf = (props: PlateLeafProps): React.ReactElement => (
  <MarkLeaf {...props} as="s" />
)

export { BoldLeaf, ItalicLeaf, MarkLeaf, StrikethroughLeaf, UnderlineLeaf }
export type { MarkLeafElement, MarkLeafProps }
